import { ActionCreator } from "redux";
import {
  ChangeHealthCardNumberAction,
  SubmitButtonDisabledStatusAction,
  IncrementNumberOfSubmitAttemptsAction,
  ToggleValidationMessageVisibilityAction,
  ChangeValidationPostalCodeValueAction,
  ToggleShowPostalCodeConfirmationModalAction,
  SelectHealthCardAcquiringModeAction,
  ACQUIRING_MODE,
  ResetAcquireMethodDataAction,
  ChangeHealthCardMaskLocationAction
} from "./type";
import {
  SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD,
  RESET_ACQUIRE_METHODE_DATA,
  TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL,
  CHANGE_VERIFICATION_POSTAL_CODE,
  TOGGLE_VALIDATION_MESSAGE_VISIBILITY,
  INCREMENT_NUMBER_OF_ATTEMPTS,
  CHANGE_BUTTON_SUBMIT_STATUS,
  CHANGE_HEALTH_CARD_NUMBER,
  CHANGE_MASK_LOCATION
} from "./constants";

/**
 * @name resetAcquireMethodData
 * @constructs ResetAcquireMethodDataAction
 */
export const resetAcquireMethodData: ActionCreator<ResetAcquireMethodDataAction> = () => ({
    type: RESET_ACQUIRE_METHODE_DATA
});

/**
 * @name selectHealthCardAcquiringMode
 * @constructs SelectHealthCardAcquiringModeAction
 * @param {ACQUIRING_MODE} method
 */
export const selectHealthCardAcquiringMode: ActionCreator<SelectHealthCardAcquiringModeAction> = (method: ACQUIRING_MODE) => ({
    type: SELECT_HEALTHCARD_NUMBER_ACQUIRING_METHOD,
    payload: {
        method
    },
});

/**
 * @name changeHealthCardNumber
 * @constructs ChangeHealthCardNumberAction
 * @param {string} healthCardNumber 
 */
export const changeHealthCardNumber: ActionCreator<ChangeHealthCardNumberAction> = (healthCardNumber: string) => ({
    type: CHANGE_HEALTH_CARD_NUMBER,
    payload: {
        healthCardNumber
    },
});

/**
 * @name submitButtonDisabledStatus
 * @constructs SubmitButtonDisabledStatusAction
 * @param {boolean} isSubmitButtonActive 
 */
export const submitButtonDisabledStatus: ActionCreator<SubmitButtonDisabledStatusAction> = (isSubmitButtonActive: boolean) => ({
    type: CHANGE_BUTTON_SUBMIT_STATUS,
    payload: {
        isSubmitButtonActive
    },
});

/**
 * @name incrementNumberOfSubmitAttempts
 * @constructs IncrementNumberOfSubmitAttemptsAction
 * @param {string} fieldType Which value in state do we increase.
 */
export const incrementNumberOfSubmitAttempts: ActionCreator<IncrementNumberOfSubmitAttemptsAction> = (fieldType: string) => ({
    type: INCREMENT_NUMBER_OF_ATTEMPTS,
    payload: {
        fieldType
    }
});

/**
 * @name toggleValidationMessageVisibility
 * @constructs ToggleValidationMessageVisibilityAction
 * @param {boolean} isValidationMessageVisible 
 * @param {string} fieldType 
 */
export const toggleValidationMessageVisibility: ActionCreator<ToggleValidationMessageVisibilityAction> = (isValidationMessageVisible: boolean, fieldType: string) => ({
    type: TOGGLE_VALIDATION_MESSAGE_VISIBILITY,
    payload: {
        isValidationMessageVisible,
        fieldType
    },
});

/**
 * @name changeValidationPostalCodeValue
 * @constructs ChangeValidationPostalCodeValueAction
 * @param {string} postalCode 
 */
export const changeValidationPostalCodeValue: ActionCreator<ChangeValidationPostalCodeValueAction> = (postalCode: string) => ({
    type: CHANGE_VERIFICATION_POSTAL_CODE,
    payload: {
        postalCode
    },
});

/**
 * @name toggleShowPostalCodeConfirmationModal
 * @constructs ToggleShowPostalCodeConfirmationModalAction
 * @param {boolean} showPostalCodeModal 
 */
export const toggleShowPostalCodeConfirmationModal: ActionCreator<ToggleShowPostalCodeConfirmationModalAction> = (showPostalCodeModal: boolean) => ({
    type: TOGGLE_POSTAL_CODE_CONFIRMATION_MODAL,
    payload: {
        showPostalCodeModal
    },
});

export const changeHealthCardMaskLocation: ActionCreator<ChangeHealthCardMaskLocationAction> = (country: string, region: string) => ({
    type: CHANGE_MASK_LOCATION,
    payload: {
        country,
        region
    },
});



// WEBPACK FOOTER //
// ./src/store/AcquireHealthCardNumber/actions.ts